import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import Spinner from "../../components/UI/Spinner";
import Aux from "../../hoc/Auxiliary";
import parse from "html-react-parser";
import i18n from "../../i18n";
import axios from "../../axios-defaults";
import UserContext from '../../context/user-context';
import {Modal} from "react-bootstrap";


class PrivacyPopup extends Component {

    static contextType = UserContext;

    constructor(props) {
        super(props);
        this.state = {
            wppageid: (i18n.language === "fr" ? PRIVACY_FR : PRIVACY_EN),
            wppageidTerms: (i18n.language === "fr" ? TERMS_FR : TERMS_EN),
            loading: false,
            pageVersion: null,
            pageVersionTerms: null,
            pageHTML: null,
            pageHTMLTerms: null,
            checkbox: false,
            checkboxTerms: false,
            show: true,
            expand_1: false,
            expand_2: false
        }
    }

    getData = () => {
        this.setState({loading: true});
        /* Mentions légales */
        axios.get(`/wordpress/v2/pages/` + this.state.wppageid)
            .then(response => {
                let pageHtml = response.data.content.rendered;
                let pageVersion = response.data.acf.version;
                this.setState({
                    pageHTML: pageHtml,
                    pageVersion: pageVersion
                });
                this.setState({loading: false})
            }).catch(error => {
            this.setState({loading: false});
            console.log('[PrivacyPopup.js] : Ajax error in getData() Legal', error.message)
        });
        /* Termes et conditions */
        axios.get(`/wordpress/v2/pages/` + this.state.wppageidTerms)
            .then(response => {

                let pageHtml = response.data.content.rendered;
                let pageVersion = response.data.acf.version;
                this.setState({
                    pageHTMLTerms: pageHtml,
                    pageVersionTerms: pageVersion
                });
                this.setState({loading: false})
            }).catch(error => {
            this.setState({loading: false});
            console.log('[PrivacyPopup.js] : Ajax error in getData() Terms', error.message)
        });
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate() {
        if (((i18n.language === "fr" ? PRIVACY_FR : PRIVACY_EN) != this.state.wppageid)
        || ((i18n.language === "fr" ? TERMS_FR : TERMS_EN) != this.state.wppageidTerms)) {
            this.setState({
                wppageid: i18n.language === "fr" ? PRIVACY_FR : PRIVACY_EN,
                wppageidTerms: i18n.language === "fr" ? TERMS_FR : TERMS_EN
            });
            this.getData();
        }
    }

    saveAgreeConditions = () => {
        axios.post(`/conditions/agree`, {version: this.state.pageVersion, versionTerms: this.state.pageVersionTerms});
    }

    canClose = () => {
        let canClose = true;
        if (this.state.pageVersion && this.context.user.infos.agreed_condition_version != this.state.pageVersion && !this.state.checkbox) {
            canClose = false;
        }
        if (this.state.pageVersionTerms && this.context.user.infos.agreed_terms_version != this.state.pageVersionTerms && !this.state.checkboxTerms) {
            canClose = false;
        }
        return canClose;
    }

    canDismiss = () => {
        if (this.context.user.infos){
            const originalUserId = this.context.user.infos.original_user_id;
            const personnificationAccountId = this.context.user.infos.personnification_account_id;

            if ((originalUserId > 0) || (!originalUserId && personnificationAccountId > 0))
                return true;
        }

        return false;
    }

    handleClose = () => {
        if (this.canClose()) {
            this.saveAgreeConditions();
            this.setState({
                show: false
            });
        }
    }

    handleDismiss = () => {
        this.setState({
            show: false
        });
    }

    handleCheck = (event) => {
        this.setState({
            checkbox: !this.state.checkbox,
        });
    }

    handleCheckTerms = (event) => {
        this.setState({
            checkboxTerms: !this.state.checkboxTerms,
        });
    }

    toggleClass1 = () => {
        const currentState = this.state.expand_1;
        this.setState({ expand_1: !currentState });
    };

    toggleClass2 = () => {
        const currentState = this.state.expand_2;
        this.setState({ expand_2: !currentState });
    };

    render() {
        const {t} = this.props;
        const {pageVersion, pageHTML,show, pageVersionTerms, pageHTMLTerms} = this.state;

        let popUp = '';

        const {user} = this.context;

        if (user.infos != null) {
            if((pageVersion && user.infos.agreed_condition_version != pageVersion) || (pageVersionTerms && user.infos.agreed_terms_version != pageVersionTerms))
            {
                if (!this.state.loading && pageHTML != null && pageHTMLTerms != null) {

                    popUp = (
                        <div>
                            <Modal show={show}
                                   onHide={this.handleClose}
                                   keyboard={true}
                                   animation={false}
                                   dialogClassName="ultimate-modal"
                            >
                                <Modal.Header>
                                    <h3 className="headline headline--c-white headline--block headline--margin--0 text-uppercase headline--weight--extra-bold headline--fs-22">
                                        {t("popup.privacypolicy")}</h3>
                                </Modal.Header>
                                <Modal.Body style={{maxHeight:"70vh"}}>
                                    {pageVersion && user.infos.agreed_condition_version != pageVersion &&
                                        <React.Fragment>
                                            <div className={`ultimate-modal__html ${this.state.expand_1 ? 'ultimate-modal__html--full': ''}`}>
                                                {parse(pageHTML)}
                                            </div>
                                            <button className="mt-3 btn btn--outline btn--fs-12 btn-expand" onClick={this.toggleClass1}>{!this.state.expand_1 ? t("popup.expand") : t("popup.minimize")}</button>
                                            <br/>
                                        </React.Fragment> }
                                    {pageVersionTerms && user.infos.agreed_terms_version != pageVersionTerms &&
                                        <React.Fragment>
                                            <div className={`ultimate-modal__html mt-3 ${this.state.expand_2 ? 'ultimate-modal__html--full': ''}`}>
                                                {parse(pageHTMLTerms)}
                                            </div>
                                            <button className="mt-3 btn btn--outline btn--fs-12 btn-expand" onClick={this.toggleClass2}>{!this.state.expand_2 ? t("popup.expand") : t("popup.minimize")}</button>
                                        </React.Fragment>}

                                </Modal.Body>
                                <div className="modal-actions d-flex justify-content-between flex-wrap">
                                    <div className="d-flex flex-column">
                                        {pageVersion && user.infos.agreed_condition_version != pageVersion &&
                                        <label className="checkbox-field checkbox-field--gray mb-3">
                                            <input
                                                type="checkbox"
                                                onChange={this.handleCheck}
                                            />
                                            <span></span>
                                            <strong>{t("popup.iacceptprivacypolicies")}</strong>
                                        </label> }
                                        {pageVersionTerms && user.infos.agreed_terms_version != pageVersionTerms &&
                                        <label className="checkbox-field checkbox-field--gray">
                                            <input
                                                type="checkbox"
                                                onChange={this.handleCheckTerms}
                                            />
                                            <span></span>
                                            <strong>{t("popup.iacceptterms")}</strong>
                                        </label> }
                                    </div>
                                    <div className="d-flex justify-end mt-3">
                                        <button className="btn btn--raised btn--raised--red" disabled={(!this.canClose())}
                                                onClick={this.handleClose}>{t("popup.confirm")}</button>
                                        {this.canDismiss() &&
                                            <button className="btn btn--raised btn--raised--red ml-3"
                                                    onClick={this.handleDismiss}>{t("popup.close")}</button>
                                        }
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    )
                    ;
                }
            }
        }
        return (
            <Aux>{popUp}</Aux>
        );

    }
}

export default withTranslation()(PrivacyPopup);

